// Suite view component for displaying a test suite

import { SuiteViewProps } from '../types';
import { TestView } from './test-view';

export function SuiteView(props: SuiteViewProps, container: HTMLElement): void {
  const { suite, suiteId, tests, errors, logs, expandFailures, showConsoleLogs } = props;
  
  // Check if suite has failing tests
  const hasFailing = suite.testIds.some((testId: string) => tests[testId] && tests[testId].status === 'failed');
  
  // Auto-expand if needed
  const autoExpand = hasFailing && expandFailures;
  
  // Create a unique ID for this suite's content
  const suiteContentId = `suite-content-${suiteId}`;
  const suiteToggleId = `suite-toggle-${suiteId}`;
  
  // Calculate stats for this suite
  const passes = suite.testIds.filter((id: string) => tests[id] && tests[id].status === 'passed').length;
  const failures = suite.testIds.filter((id: string) => tests[id] && tests[id].status === 'failed').length;
  const total = suite.testIds.length;
  
  // Create suite container
  const suiteDiv = document.createElement('div');
  suiteDiv.className = 'msdr-suite';
  
  // Create suite header
  const suiteHeader = document.createElement('div');
  suiteHeader.className = 'msdr-suite-header';
  suiteHeader.addEventListener('click', () => toggleSuite());
  
  const toggleIcon = document.createElement('span');
  toggleIcon.id = suiteToggleId;
  toggleIcon.className = `msdr-toggle-icon ${autoExpand ? 'expanded' : ''}`;
  toggleIcon.textContent = '▶';
  
  const suiteTitle = document.createElement('span');
  suiteTitle.className = 'msdr-suite-title';
  suiteTitle.textContent = suite.title;
  
  const suiteStats = document.createElement('span');
  suiteStats.className = 'msdr-suite-stats';
  suiteStats.textContent = `${passes}✓ ${failures}✗ ${total}T`;
  
  suiteHeader.appendChild(toggleIcon);
  suiteHeader.appendChild(suiteTitle);
  suiteHeader.appendChild(suiteStats);
  
  // Create suite content
  const suiteContent = document.createElement('div');
  suiteContent.id = suiteContentId;
  suiteContent.className = `msdr-suite-content ${autoExpand ? 'expanded' : ''}`;
  
  // Generate test views
  suite.testIds.forEach((testId: string) => {
    const test = tests[testId];
    if (!test) return;
    
    // Get error for this test if it failed
    const error = test.errId ? errors[test.errId] : undefined;
    
    // Get logs for this test
    const testLogs = Object.values(logs).filter((log: any) => log.testId === testId);
    
    TestView({
      test,
      error,
      logs: testLogs,
      showConsoleLogs,
      expanded: expandFailures && test.status === 'failed'
    }, suiteContent);
  });
  
  // Handle suite toggle
  function toggleSuite() {
    const content = document.getElementById(suiteContentId);
    const toggle = document.getElementById(suiteToggleId);
    if (content && toggle) {
      content.classList.toggle('expanded');
      toggle.classList.toggle('expanded');
    }
  }
  
  suiteDiv.appendChild(suiteHeader);
  suiteDiv.appendChild(suiteContent);
  container.appendChild(suiteDiv);
}
